export const FETCH_RESTAURANT_INFORMATION_REQUEST = 'FETCH_RESTAURANT_INFORMATION_REQUEST'
export const FETCH_RESTAURANT_INFORMATION_SUCCESS = 'FETCH_RESTAURANT_INFORMATION_SUCCESS'
export const FETCH_RESTAURANT_INFORMATION_FALIURE = 'FETCH_RESTAURANT_INFORMATION_FALIURE'
export const FETCH_OFFERSLIST_SUCCESS = 'FETCH_OFFERSLIST_SUCCESS'
